import {createStore, applyMiddleware} from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import {routerMiddleware} from 'react-router-redux';
import {composeWithDevTools} from 'redux-devtools-extension';

import {api, refreshToken} from 'redux/middleware';
import rootReducer from './reducers';

// const sagaMiddleware = createSagaMiddleware();
const routerMiddlewares = routerMiddleware();
let middlewares = [refreshToken, routerMiddlewares, thunk, api];

if (process.env.NODE_ENV !== 'production') {
  middlewares.push(logger);
}

const configureStore = initialState => {
  const store = createStore(
    rootReducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middlewares))
  );
  // store.runSaga = sagaMiddleware.run;
  // store.close = () => store.dispatch(END);
  return store;
};

export default configureStore;
